module.exports = __webpack_public_path__ + "img/cases-part1-5.c86f18c5.png";